import { Component, Vue } from 'vue-property-decorator';

type MouseEventFunc = (e: MouseEvent) => void;

interface MakeResizableOptions {
  borderClass?: string;
  minWidth?: number;
}

@Component
export class ResizableDrawerMixin extends Vue {
  private __onMousedown?: MouseEventFunc;
  private __onMouseup?: MouseEventFunc;
  private _drawerBorder?: HTMLElement;

  makeResizable(
    drawerRef: HTMLElement,
    setWidthFunc: (width: string | number) => void,
    options: MakeResizableOptions = {},
  ): void {
    this._addEventsListeners(drawerRef, setWidthFunc, options);
    this._setBorderWidth();
  }

  destroyed(): void {
    this._removeEventsListeners();
  }

  private _setBorderWidth() {
    const border = this._drawerBorder;
    if (border) {
      border.style.width = '4px';
      border.style.cursor = 'ew-resize';
    }
  }

  private _addEventsListeners(
    drawerRef: HTMLElement,
    setWidthFunc: (width: string | number) => void,
    options: MakeResizableOptions,
  ) {
    const el = drawerRef;
    const borderClass = options.borderClass || 'v-navigation-drawer__border';
    const drawerBorder = el.getElementsByClassName(
      borderClass,
    )[0] as HTMLElement;
    const direction = el.classList.contains('v-navigation-drawer--right')
      ? 'right'
      : 'left';

    const resize = (e: any) => {
      document.body.style.cursor = 'ew-resize';
      let f =
        direction === 'right'
          ? document.body.scrollWidth - e.clientX
          : e.clientX;
      if (options.minWidth) {
        f = f < options.minWidth ? options.minWidth : f;
      }
      if (setWidthFunc) {
        setWidthFunc(f);
      }
      // el.style.width = f + 'px';
      e.stopPropagation();
    };

    const disableSelect = (e: any) => {
      e.preventDefault();
    };

    const onMousedown = (e: MouseEvent) => {
      el.style.transition = 'initial';
      e.stopPropagation();
      document.addEventListener('mousemove', resize);
      document.addEventListener('selectstart', disableSelect);
    };
    const onMouseup = () => {
      el.style.transition = '';

      document.body.style.cursor = '';
      document.removeEventListener('mousemove', resize);
      document.removeEventListener('selectstart', disableSelect);
    };

    drawerBorder.addEventListener('mousedown', onMousedown);
    document.addEventListener('mouseup', onMouseup);

    this.__onMousedown = onMousedown;
    this.__onMouseup = onMouseup;
    this._drawerBorder = drawerBorder;
  }

  private _removeEventsListeners() {
    if (this.__onMousedown && this._drawerBorder) {
      this._drawerBorder.addEventListener(
        'mousedown',
        this.__onMousedown,
        false,
      );
    }
    if (this.__onMouseup) {
      document.removeEventListener('mouseup', this.__onMouseup);
    }
  }
}
